// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeShareLinkGetBody = {
  poolId: string;
};

export type typeShareLinkGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { shareCode: string; shareUrl: string; active: boolean };
};

export type typeShareLinkGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeShareLinkGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeShareLinkGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaShareLinkGetBody = {
  type: "object",
  properties: { poolId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createShareLinkGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaShareLinkGetBody);
  }

  return async function postShareLinkGet(
    payload: typeShareLinkGetBody,
  ): Promise<typeShareLinkGetOutput200 | typeShareLinkGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postShareLinkGet" failed before calling the network. #9cebac65bc39`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#9cebac65bc39" },
        },
        data: null,
      } as typeShareLinkGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/share-link/get`,
      httpMethod: "POST",
      options,
    })) as typeShareLinkGetOutput200 | typeShareLinkGetOutput400;
  };
}
